import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
} from "@ey-xd/motif-react";
import React, { useEffect } from "react";
import Button from "../Button/Button";
import "./SessionPopUp.scss";
import {
  resetUseSessionMessage,
  showUserSessionMessage,
} from "../../store/slices/UserSessionMessageSlice";
import { useAppDispatch } from "../../store/hooks";
import { SESSSIION_TIMEOUT_MESSAGE } from "../../Constant";
import { getUserLogout } from "../../store/slices/UserLogoutSlice";
import {
  notifySessionContinueAcrossTabs,
  removeOpportunityCodeFromLocal,
} from "../../utils/common";
type Props = {
  isVisible: boolean;
};

export default function SessionPopUp({ isVisible }: Props) {
  const [show, setShow] = React.useState(isVisible);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!show) {
      dispatch(resetUseSessionMessage());
    } else {
      dispatch(showUserSessionMessage());
    }
    // on component unmount
    return () => {
      dispatch(resetUseSessionMessage());
    };
  }, [dispatch, show]);

  return (
    <>
      <MotifModal
        className="sessionModal"
        onClose={() => setShow(false)}
        show={show}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="sessionModalWrapper">
          <MotifModalBody>
            <span className="discard_heading">
              {SESSSIION_TIMEOUT_MESSAGE.TITLE}
            </span>
            <div className="discard_message">
              {SESSSIION_TIMEOUT_MESSAGE.MESSAGE}
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={"cancel"}
              variant={"secondary"}
              className="delBtn hide"
              onClickHandler={() => {
                setShow(false);
              }}
            />
            <Button
              label={SESSSIION_TIMEOUT_MESSAGE.BUTTON_TEXT_LOGOUT}
              variant={"primary"}
              className="delBtn"
              onClickHandler={() => {
                dispatch(resetUseSessionMessage());
                dispatch(getUserLogout());
                removeOpportunityCodeFromLocal();
                window.SN_CSM_EC?.close();
                setShow(false);
              }}
            />
            <Button
              label={SESSSIION_TIMEOUT_MESSAGE.BUTTON_TEXT_CONTINUE}
              variant={"secondary"}
              className="cancelBtnModal"
              onClickHandler={() => {
                notifySessionContinueAcrossTabs();
                setShow(false);
              }}
            />
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}
